import { render, staticRenderFns } from "./goPayment.vue?vue&type=template&id=12c6d182&"
import script from "./goPayment.vue?vue&type=script&lang=js&"
export * from "./goPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports